import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function NyPatient() {
  return (
    <main className="pt-32 pb-24">
      <Helmet>
        <title>Ny Patient? Sådan skifter du læge | Hellerup Lægehus</title>
        <meta name="description" content="Vil du skifte til Hellerup Lægehus? Læs om tilmelding, lukket patienttilgang, og hvordan du får overført din journal fra din tidligere læge her." />
        <meta property="og:title" content="Ny Patient? Sådan skifter du læge | Hellerup Lægehus" />
        <meta property="og:description" content="Vil du skifte til Hellerup Lægehus? Læs om tilmelding, lukket patienttilgang, og hvordan du får overført din journal fra din tidligere læge her." />
        <html lang="da-DK" />
      </Helmet>
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-12">
          <div className="flex items-center gap-4 mb-6">
            <div className="h-[1px] w-12 bg-[#4b717a]" />
            <span className="text-[#4b717a] text-xs tracking-[0.4em] uppercase font-bold">Information</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-sans font-medium text-black mb-8 leading-tight tracking-tight">
            Ny patient?
          </h1>
        </div>

        <div className="max-w-3xl prose prose-slate prose-lg
            prose-headings:font-sans prose-headings:font-medium prose-headings:text-black prose-headings:leading-tight prose-headings:tracking-tight
            prose-p:text-slate-600 prose-p:leading-relaxed
            prose-a:text-[#4b717a] prose-a:no-underline hover:prose-a:underline
            prose-strong:text-slate-900
            prose-ul:list-disc prose-ol:list-decimal">
          
          <p>
            Hellerup Lægehus vil i løbet af året have skiftevis åben og lukket for tilgang af nye patienter, som besluttes af Regionen Hovedstaden. For at skifte til Hellerup Lægehus kan du ansøge om dette via <a href="https://www.borger.dk" target="_blank" rel="noopener noreferrer" className="font-bold"><strong>www.borger.dk</strong></a> eller ringe til Borgerservice i din kommune.
          </p>
          
          <div className="my-12 py-8 border-y border-slate-100">
            <p className="font-medium text-slate-900 italic">
              Når vi har lukket for tilgang kan du under visse forudsætninger alligevel blive patient i Hellerup Lægehus. Du skal Google følgende blanket ”Tilmelding til læge med lukket patienttilgang” hvor de specifikke kriterier fremgår.
            </p>
          </div>
          
          <p>
            Blanketten skal du printe, udfylde og efter forudgået aftale aflevere i klinikken.
          </p>

          <h2 className="text-3xl font-sans font-medium text-black mt-12 mb-6">Journal fra tidligere læge</h2>
          
          <p>
            Vi oplever desværre, at overførsel af journal fra tidligere læge ikke sker automatisk. Dette på trods af, at man som borger “vinger af”, at tidligere læge må overføre journal til os. Vi beder derfor nye patienter om at kontakte tidligere læge mhp fremsendesle af journal til os. Tusind tak for hjælpen.
          </p>
        </div>
      </div>
    </main>
  );
}
